import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.08)',
    borderRadius: ({ smallMedia }) => (smallMedia ? '0' : '0.5rem'),
    maxHeight: '100%',
    backgroundColor: 'white',
    maxWidth: '1610px'
  },

  container: {
    display: 'grid',
    gridTemplateColumns: '24rem minmax(0px, auto)',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'unset',
      gridTemplateRows: 'auto auto'
    }
  }
}))

export default useStyles
